import { useState, useEffect } from 'react';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import TaskForm from './taskForm';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import { getAccountList, getContactList, getUser } from '../../redux/selector';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { accountInputData, contactInputData, ticketInputData } from '../../shared/constants';
import { validationSchemaTicket } from './validationSchema';
import { initValueTicket } from '../../shared/initials';

const AddTasksForm = ({}) => {
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'timeZone'
  );
  const [formData, setFormData] = useState(initValueTicket);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(storeLoading);
  const [minDate, setMinDate] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector(getUser);
  // Update owner in initValueLead if it is an empty string
  if (!initValueTicket.owner) {
    initValueTicket.owner = userInfo?.user?.display_name;
    initValueTicket.ownerId = userInfo?.user?.userId;
  }
  const handleCloseAddForm = () => {
    navigate('/tickets');
  };

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = today.getFullYear();
    const formattedDate = `${year}-${month}-${day}`; // Format for input[type="date"]
    setMinDate(formattedDate);
  }, []);

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      reminder: dataTime,
    });
  };
  const handleSubmit = async (formData) => {
    try {
      await validationSchemaTicket.validate(formData, { abortEarly: false });

      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };
  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ticketId') {
      setFormData({
        ...formData,
        ticketId: selectedId,
        ticket: selectedValue,
        // Clear lead/contact data when switching
        leadId: selectedValue === 'contact' ? '' : formData.leadId,
        leadName: selectedValue === 'contact' ? '' : formData.leadName,
        contactId: selectedValue === 'lead' ? '' : formData.contactId,
        contactName: selectedValue === 'lead' ? '' : formData.contactName,
      });
      setFormEdited(true);
    } else if (name === 'associateId') {
      setFormData({
        ...formData,
        associateId: selectedId,
        associate: selectedValue,
        // Clear previous deal data when switching
        accountId: selectedValue === 'account' ? formData.accountId : '',
        accountName: selectedValue === 'account' ? formData.accountName : '',
        opportunityId: selectedValue === 'opportunity' ? formData.opportunityId : '',
        opportunityName: selectedValue === 'opportunity' ? formData.opportunityName : '',
        campaignId: selectedValue === 'campaign' ? formData.campaignId : '',
        campaignName: selectedValue === 'campaign' ? formData.campaignName : '',
      });
      setFormEdited(true);
    } else if (name === 'leadId') {
      setFormData({
        ...formData,
        leadId: selectedId,
        leadName: selectedValue,
        // Clear contact data when selecting lead
        contactId: '',
        contactName: '',
      });
      setFormEdited(true);
    } else if (name === 'opportunityId') {
      setFormData({
        ...formData,
        opportunityId: selectedId,
        opportunityName: selectedValue,
        // Clear other deal data
        accountId: '',
        accountName: '',
        campaignId: '',
        campaignName: '',
      });
      setFormEdited(true);
    } else if (name === 'campaignId') {
      setFormData({
        ...formData,
        campaignId: selectedId,
        campaignName: selectedValue,
        // Clear other deal data
        accountId: '',
        accountName: '',
        opportunityId: '',
        opportunityName: '',
      });
      setFormEdited(true);
    } else if (name === 'contactId') {
      setFormData({
        ...formData,
        contactId: selectedId,
        contactName: selectedValue,
        // Clear lead data when selecting contact
        leadId: '',
        leadName: '',
      });
      setFormEdited(true);
    } else if (name === 'accountId') {
      setFormData({
        ...formData,
        accountId: selectedId,
        accountName: selectedValue,
        // Clear other deal data
        opportunityId: '',
        opportunityName: '',
        campaignId: '',
        campaignName: '',
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        status: selectedValue,
        statusId: selectedId,
      });
      setFormEdited(true);
    } else if (name === 'priorityId') {
      setFormData({
        ...formData,
        priority: selectedValue,
        priorityId: selectedId,
      });
      setFormEdited(true);
    }
  };

  useEffect(() => {
    // Initialize default values for associate and ticket without pre-selecting dropdowns
    if (!formData?.associate && formData.type === 'add') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        associate: 'Account', // Default associate value
      }));
      setSelectedOptions((prevSelectedOptions) => ({
        ...prevSelectedOptions,
        associateId: { value: 'account', label: 'Account' },
      }));
    }

    if (!formData?.ticket && formData.type === 'add') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ticket: 'contact', // Default ticket value
      }));
      setSelectedOptions((prevSelectedOptions) => ({
        ...prevSelectedOptions,
        ticketId: { value: 'contact', label: 'Contact' },
      }));
    }
  }, []); // Empty dependency array to run only once on mount

  const updateList = (msg, id) => {
    setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });
    // dispatch(fetchDataAndUpdateStore({ key: "ticketList", inputData: ticketInputData }));
    dispatch(
      singleRowAddUpdateInStore({
        moduleName: 'Ticket',
        id: formData.type === 'add' ? id : formData.id,
        rowIndex: formData.rowIndex,
      })
    );
    navigate('/tickets');
  };

  const handleFormSubmit = (formData) => {
    let updatedFormData = { ...formData };

    if (formData.ticket === 'Lead') {
      updatedFormData = {
        ...updatedFormData,
        accountId: '',
        accountName: '',
        opportunityId: '',
        opportunityName: '',
        campaignId: '',
        campaignName: '',
      };
    }
    setLoading(true);
    if (formData.type === 'add') {
      apiServices
        .createTicketList(updatedFormData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            updateList('Ticket created successfully!', id);
            setLoading(false);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code
            const status = error.response.status;

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
          }
          setLoading(false);
        });
    } else {
      apiServices
        .updateTicketList(updatedFormData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Ticket updated successfully!');
            setLoading(false);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code
            const status = error.response.status;

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
          }
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (!location) return; //

    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('addTicket') ? 'add' : 'edit',
    };

    let updatedSelectedOptions = { ...selectedOptions }; // ✅ Store updates in a single object

    if (location.pathname.includes('editTicket') && location.state) {
      const { leadId, contactId, accountId, campaignId, opportunityId } = location.state;

      updatedFormData = { ...location.state, type: 'edit' };

      if (leadId) {
        updatedFormData.ticket = 'Lead';
        updatedFormData.ticketId = 'lead';
        updatedSelectedOptions.ticketId = { value: 'lead', label: 'Lead' };
      } else if (contactId) {
        updatedFormData.ticket = 'Contact';
        updatedFormData.ticketId = 'contact';
        updatedSelectedOptions.ticketId = {
          value: 'contact',
          label: 'Contact',
        };
      }

      if (accountId) {
        updatedFormData.associate = 'Account';
        updatedFormData.associateId = 'account';
        updatedSelectedOptions.associateId = {
          value: 'account',
          label: 'Account',
        };
      } else if (campaignId) {
        updatedFormData.associate = 'Campaign';
        updatedFormData.associateId = 'campaign';
        updatedSelectedOptions.associateId = {
          value: 'campaign',
          label: 'Campaign',
        };
      } else if (opportunityId) {
        updatedFormData.associate = 'Opportunity';
        updatedFormData.associateId = 'opportunity';
        updatedSelectedOptions.associateId = {
          value: 'opportunity',
          label: 'Opportunity',
        };
      }
    }

    setFormData(updatedFormData);
    setSelectedOptions(updatedSelectedOptions);
  }, [location]);

  return (
    <div className="addlead_container">
      <div className="viewHeader viewshadow">
        <HeaderProfileBlock localData={formData} moduleName={'Ticket'} />
        <div className="rightAction">
          <button
            type="button"
            className="btn btn-outline-primary"
            data-bs-dismiss="modal"
            onClick={handleCloseAddForm}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              handleSubmit(formData);
            }}
            disabled={(formData?.type === 'edit' && !formEdited) || loading}
          >
            {loading && (
              <>
                {' '}
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
              </>
            )}
            {loading ? 'Loading...' : 'Save'}
          </button>
        </div>
      </div>
      <TaskForm
        formData={formData}
        selectedOptions={selectedOptions}
        handleSubmit={handleSubmit}
        handleChangeForm={handleChangeForm}
        handleChange={handleChange}
        handleDateTime={handleDateTime}
        errormsg={errormsg}
      />
    </div>
  );
};

export default AddTasksForm;
